<template>
  <div class="setting-page">
    <a-page-header title="基本信息管理" sub-title="统一维护 PC 门户与微信小程序展示的企业信息" />

    <a-spin :spinning="loading">
      <a-form-model :model="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 15 }" class="setting-form">
        <a-divider orientation="left">企业基本信息</a-divider>
        <a-form-model-item label="公司名称">
          <a-input v-model="form.companyName" placeholder="请输入公司名称" />
        </a-form-model-item>
        <a-form-model-item label="公司地址">
          <a-input v-model="form.companyAddress" placeholder="请输入公司地址" />
        </a-form-model-item>
        <a-form-model-item label="联系电话">
          <a-input v-model="form.servicePhone" placeholder="请输入联系电话" />
        </a-form-model-item>
        <a-divider orientation="left">上门自提信息</a-divider>
        <a-form-model-item label="自提地址">
          <a-input v-model="form.pickupAddress" placeholder="请输入上门自提地址" />
        </a-form-model-item>
        <a-form-model-item label="自提联系人">
          <a-input v-model="form.pickupContact" placeholder="请输入自提联系人" />
        </a-form-model-item>
        <a-form-model-item label="自提电话">
          <a-input v-model="form.pickupPhone" placeholder="请输入自提联系电话" />
        </a-form-model-item>
        <a-form-model-item label="自提时间">
          <a-input v-model="form.pickupHours" placeholder="例如：周一至周六 9:00-18:00" />
        </a-form-model-item>
        <a-form-model-item v-for="item in companyImageFields" :key="item.key" :label="item.label">
          <a-upload name="file" list-type="picture-card" :file-list="getSingleImageList(item.key)"
            :action="uploadAction" :headers="uploadHeaders" :before-upload="beforeImageUpload"
            @change="info => handleSingleImageChange(info, item.key)">
            <div v-if="!form[item.key]"><a-icon type="plus" /><div class="upload-text">上传图片</div></div>
          </a-upload>
        </a-form-model-item>

        <a-divider orientation="left">商城展示信息</a-divider>
        <a-form-model-item label="商城名称">
          <a-input v-model="form.mallName" placeholder="请输入商城名称" />
        </a-form-model-item>
        <a-form-model-item label="原厂直销品牌">
          <a-textarea v-model="directBrandsText" :rows="3" placeholder="每行填写一个品牌，保存后小程序和PC首页同步更新" />
        </a-form-model-item>
        <a-form-model-item label="授权代理品牌">
          <a-textarea v-model="agentBrandsText" :rows="3" placeholder="每行填写一个品牌" />
        </a-form-model-item>

        <a-divider orientation="left">小程序品牌专区</a-divider>
        <div class="brand-zone-editor">
          <section v-for="section in brandZoneSections" :key="section.key" class="brand-zone-section">
            <div class="brand-zone-heading">
              <strong>{{ section.title }}</strong>
              <a-button type="primary" ghost icon="plus" size="small" @click="addBrandZoneItem(section.key)">新增</a-button>
            </div>
            <a-empty v-if="!brandZone[section.key].length" :description="'暂无' + section.title" />
            <a-row v-else :gutter="16">
              <a-col v-for="(item, index) in brandZone[section.key]" :key="item.id" :span="8">
                <a-card class="brand-zone-card" size="small">
                  <div class="brand-zone-image" :class="'brand-zone-image-' + section.key">
                    <img v-if="item.image" :src="normalizeUploadAssetUrl(item.image)" :alt="section.imageLabel">
                    <a-icon v-else type="picture" />
                  </div>
                  <a-upload
                    name="file"
                    :show-upload-list="false"
                    :action="uploadAction"
                    :headers="uploadHeaders"
                    :before-upload="beforeImageUpload"
                    @change="info => handleBrandZoneImageChange(info, section.key, index)"
                  >
                    <a-button block icon="upload" size="small">{{ item.image ? '更换' : '上传' }}{{ section.imageLabel }}</a-button>
                  </a-upload>
                  <a-form-model-item v-for="field in section.fields" :key="field.key" :label="field.label" class="brand-zone-field">
                    <a-textarea
                      v-if="field.multiline"
                      v-model="item[field.key]"
                      :rows="4"
                      :placeholder="'请输入' + field.label"
                    />
                    <a-input v-else v-model="item[field.key]" :placeholder="'请输入' + field.label" />
                  </a-form-model-item>
                  <div class="brand-zone-actions">
                    <a-button icon="arrow-up" size="small" :disabled="index === 0" @click="moveBrandZoneItem(section.key, index, -1)" />
                    <a-button icon="arrow-down" size="small" :disabled="index === brandZone[section.key].length - 1" @click="moveBrandZoneItem(section.key, index, 1)" />
                    <a-button type="danger" ghost icon="delete" size="small" @click="removeBrandZoneItem(section.key, index)">删除</a-button>
                  </div>
                </a-card>
              </a-col>
            </a-row>
          </section>
        </div>
        <a-form-model-item label="客服说明">
          <a-input v-model="form.customerServiceText" placeholder="例如：微信扫码联系客服" />
        </a-form-model-item>
        <a-form-model-item label="海报选择">
          <a-upload
            name="file"
            list-type="picture-card"
            :file-list="posterFileList"
            :action="uploadAction"
            :headers="uploadHeaders"
            :before-upload="beforeImageUpload"
            @change="handlePosterChange"
          >
            <div>
              <a-icon type="plus" />
              <div class="upload-text">上传海报</div>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 15, offset: 3 }">
          <a-button type="primary" icon="save" :loading="saving" @click="handleSave">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </div>
</template>

<script>
import { API_BASE_URL, getMallBasicSetting, saveMallBasicSetting } from '@/api'
import adminSession from '@/utils/adminSession'

export default {
  data() {
    return {
      loading: false,
      saving: false,
      form: {
        id: 1,
        mallName: '',
        companyName: '',
        companyAddress: '',
        servicePhone: '',
        pickupAddress: '',
        pickupContact: '',
        pickupPhone: '',
        pickupHours: '',
        posterImages: '[]',
        wechatQrCode: '',
        miniProgramQrCode: '',
        companyLogo: '',
        directBrandsJson: '[]',
        agentBrandsJson: '[]',
        authorizedAgentsJson: '[]',
        partnerBrandsJson: '[]',
        applicationScenesJson: '[]',
        customerServiceText: ''
      },
      directBrandsText: '',
      agentBrandsText: '',
      posterFileList: [],
      singleImageMap: {},
      companyImageFields: [
        { key: 'wechatQrCode', label: '微信二维码' },
        { key: 'miniProgramQrCode', label: '小程序二维码' },
        { key: 'companyLogo', label: '公司Logo' }
      ],
      brandZoneSections: [
        { key: 'authorizedAgents', title: '授权代理', imageLabel: '授权图片', fields: [{ key: 'name', label: '名称' }] },
        { key: 'partnerBrands', title: '品牌专区', imageLabel: '品牌Logo', fields: [{ key: 'name', label: '名称' }, { key: 'introduction', label: '品牌介绍', multiline: true }] },
        { key: 'applicationScenes', title: '应用场景', imageLabel: '场景图片', fields: [{ key: 'name', label: '名称' }] }
      ],
      brandZone: {
        authorizedAgents: [],
        partnerBrands: [],
        applicationScenes: []
      },
      uploadAction: API_BASE_URL + '/upload/image'
    }
  },
  computed: {
    uploadHeaders() {
      const token = adminSession.getAdminToken()
      return token ? { Authorization: 'Bearer ' + token } : {}
    }
  },
  created() {
    this.loadSetting()
  },
  methods: {
    loadSetting() {
      this.loading = true
      getMallBasicSetting().then(res => {
        const data = res.data || {}
        this.form = {
          id: 1,
          mallName: data.mallName || '',
          companyName: data.companyName || '',
          companyAddress: data.companyAddress || '',
          servicePhone: data.servicePhone || '',
          pickupAddress: data.pickupAddress || '',
          pickupContact: data.pickupContact || '',
          pickupPhone: data.pickupPhone || '',
          pickupHours: data.pickupHours || '',
          posterImages: data.posterImages || '[]',
          wechatQrCode: data.wechatQrCode || '',
          miniProgramQrCode: data.miniProgramQrCode || '',
          companyLogo: data.companyLogo || '',
          directBrandsJson: data.directBrandsJson || '[]',
          agentBrandsJson: data.agentBrandsJson || '[]',
          authorizedAgentsJson: data.authorizedAgentsJson || '[]',
          partnerBrandsJson: data.partnerBrandsJson || '[]',
          applicationScenesJson: data.applicationScenesJson || '[]',
          customerServiceText: data.customerServiceText || ''
        }
        this.directBrandsText = this.parsePosterImages(this.form.directBrandsJson).join('\n')
        this.agentBrandsText = this.parsePosterImages(this.form.agentBrandsJson).join('\n')
        this.brandZone = {
          authorizedAgents: this.parseBrandZoneItems(this.form.authorizedAgentsJson, 'authorizedAgents'),
          partnerBrands: this.parseBrandZoneItems(this.form.partnerBrandsJson, 'partnerBrands'),
          applicationScenes: this.parseBrandZoneItems(this.form.applicationScenesJson, 'applicationScenes')
        }
        this.singleImageMap = {}
        this.posterFileList = this.parsePosterImages(this.form.posterImages).map((url, index) => ({
          uid: 'poster-' + index,
          name: '海报' + (index + 1),
          status: 'done',
          storageUrl: this.toStorageAssetUrl(url),
          url: this.normalizeUploadAssetUrl(url)
        }))
      }).finally(() => {
        this.loading = false
      })
    },
    parsePosterImages(value) {
      try {
        const parsed = JSON.parse(value || '[]')
        return Array.isArray(parsed) ? parsed.filter(Boolean) : []
      } catch (e) {
        return []
      }
    },
    parseBrandZoneItems(value, key) {
      try {
        const parsed = JSON.parse(value || '[]')
        if (!Array.isArray(parsed)) return []
        return parsed.filter(item => item && typeof item === 'object').map(item => ({
          id: item.id || this.createBrandZoneId(key),
          image: this.toStorageAssetUrl(item.image || ''),
          ...(key === 'authorizedAgents' ? { name: String(item.name || '') } : {}),
          ...(key === 'partnerBrands' ? { name: String(item.name || ''), introduction: String(item.introduction || '') } : {}),
          ...(key === 'applicationScenes' ? { name: String(item.name || '') } : {})
        }))
      } catch (e) {
        return []
      }
    },
    createBrandZoneId(prefix) {
      return prefix + '-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8)
    },
    addBrandZoneItem(key) {
      const item = { id: this.createBrandZoneId(key), image: '' }
      if (key === 'authorizedAgents') item.name = ''
      if (key === 'partnerBrands') Object.assign(item, { name: '', introduction: '' })
      if (key === 'applicationScenes') item.name = ''
      this.brandZone[key].push(item)
    },
    removeBrandZoneItem(key, index) {
      this.brandZone[key].splice(index, 1)
    },
    moveBrandZoneItem(key, index, offset) {
      const target = index + offset
      if (target < 0 || target >= this.brandZone[key].length) return
      const list = this.brandZone[key]
      const item = list.splice(index, 1)[0]
      list.splice(target, 0, item)
    },
    handleBrandZoneImageChange(info, key, index) {
      if (!info.file || info.file.status !== 'done') return
      let response = info.file.response || {}
      if (typeof response === 'string') {
        try {
          response = JSON.parse(response || '{}')
        } catch (e) {
          response = {}
        }
      }
      if (response.code !== 200 || !response.data) {
        this.$message.error(response.msg || '图片上传失败')
        return
      }
      const item = this.brandZone[key][index]
      if (!item) return
      this.$set(item, 'image', this.toStorageAssetUrl(response.data.path || response.data.url))
    },
    beforeImageUpload(file) {
      const isImage = file.type.indexOf('image/') === 0
      if (!isImage) {
        this.$message.error('仅支持上传图片')
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过5MB')
      }
      return isImage && isLt5M
    },
    toStorageAssetUrl(url) {
      const value = String(url || '').trim()
      const uploadIndex = value.indexOf('/uploads/')
      return uploadIndex >= 0 ? value.slice(uploadIndex).split(/[?#]/)[0] : value
    },
    normalizeUploadAssetUrl(url) {
      const value = String(url || '').trim()
      const uploadIndex = value.indexOf('/uploads/')
      if (uploadIndex >= 0) return API_BASE_URL.replace(/\/$/, '') + value.slice(uploadIndex).split(/[?#]/)[0]
      return value
    },
    handlePosterChange(info) {
      this.posterFileList = info.fileList.map(file => {
        if (file.status === 'done') {
          let response = file.response || {}
          if (typeof response === 'string') {
            try {
              response = JSON.parse(response || '{}')
            } catch (e) {
              response = {}
            }
          }
          if (response.code === 200 && response.data) {
            file.storageUrl = this.toStorageAssetUrl(response.data.path || response.data.url || file.storageUrl || file.url)
            file.url = this.normalizeUploadAssetUrl(file.storageUrl)
          }
        }
        return file
      }).filter(file => file.status !== 'error')
    },
    getSingleImageList(key) {
      if (this.singleImageMap[key]) return this.singleImageMap[key]
      if (!this.form[key]) return []
      return [{ uid: key, name: this.companyImageFields.find(item => item.key === key).label, status: 'done', url: this.normalizeUploadAssetUrl(this.form[key]) }]
    },
    handleSingleImageChange(info, key) {
      const files = info.fileList.slice(-1)
      this.$set(this.singleImageMap, key, files)
      if (info.file.status === 'removed') {
        this.$set(this.form, key, '')
        return
      }
      if (info.file.status !== 'done') return
      const response = info.file.response || {}
      if (response.code !== 200 || !response.data) {
        this.$message.error(response.msg || '图片上传失败')
        return
      }
      const storageUrl = this.toStorageAssetUrl(response.data.path || response.data.url)
      this.$set(this.form, key, storageUrl)
      this.$set(this.singleImageMap, key, [{ uid: info.file.uid, name: info.file.name, status: 'done', url: this.normalizeUploadAssetUrl(storageUrl) }])
    },
    handleSave() {
      const images = this.posterFileList.map(file => this.toStorageAssetUrl(file.storageUrl || file.url)).filter(Boolean)
      if (!this.form.companyName || !this.form.companyAddress || !this.form.servicePhone) {
        this.$message.warning('请完整填写公司名称、公司地址和联系电话')
        return
      }
      if (!this.form.wechatQrCode || !this.form.miniProgramQrCode || !this.form.companyLogo) {
        this.$message.warning('请上传微信二维码、小程序二维码和公司Logo')
        return
      }
      if (!this.form.mallName) {
        this.$message.warning('请输入商城名称')
        return
      }
      if (!images.length) {
        this.$message.warning('请至少上传一张海报')
        return
      }
      if (!this.validateBrandZone()) return
      this.saving = true
      saveMallBasicSetting({
        ...this.form,
        id: 1,
        posterImages: JSON.stringify(images),
        directBrandsJson: JSON.stringify(this.splitLines(this.directBrandsText)),
        agentBrandsJson: JSON.stringify(this.splitLines(this.agentBrandsText)),
        authorizedAgentsJson: JSON.stringify(this.serializeBrandZoneItems('authorizedAgents')),
        partnerBrandsJson: JSON.stringify(this.serializeBrandZoneItems('partnerBrands')),
        applicationScenesJson: JSON.stringify(this.serializeBrandZoneItems('applicationScenes'))
      }).then(() => {
        this.$message.success('保存成功')
        this.loadSetting()
      }).finally(() => {
        this.saving = false
      })
    },
    splitLines(value) {
      return String(value || '').split(/\r?\n|,/).map(item => item.trim()).filter(Boolean)
    },
    serializeBrandZoneItems(key) {
      return this.brandZone[key].map(item => ({
        id: item.id,
        image: this.toStorageAssetUrl(item.image),
        ...(key === 'authorizedAgents' ? { name: String(item.name || '').trim() } : {}),
        ...(key === 'partnerBrands' ? { name: String(item.name || '').trim(), introduction: String(item.introduction || '').trim() } : {}),
        ...(key === 'applicationScenes' ? { name: String(item.name || '').trim() } : {})
      }))
    },
    validateBrandZone() {
      const invalidAgent = this.brandZone.authorizedAgents.some(item => !item.image || !String(item.name || '').trim())
      if (invalidAgent) {
        this.$message.warning('请完整填写授权代理的图片和名称')
        return false
      }
      const invalidPartner = this.brandZone.partnerBrands.some(item => !item.image || !String(item.name || '').trim() || !String(item.introduction || '').trim())
      if (invalidPartner) {
        this.$message.warning('请完整填写品牌专区的Logo、名称和介绍')
        return false
      }
      if (this.brandZone.applicationScenes.some(item => !item.image || !String(item.name || '').trim())) {
        this.$message.warning('请完整填写应用场景的图片和名称')
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>
.setting-page {
  padding: 20px;
  background: #fff;
}
.setting-form {
  max-width: 980px;
}
.upload-text {
  margin-top: 8px;
}
.brand-zone-editor {
  margin: 0 0 24px 12.5%;
  max-width: 860px;
}
.brand-zone-section + .brand-zone-section {
  margin-top: 28px;
}
.brand-zone-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 15px;
}
.brand-zone-card {
  margin-bottom: 16px;
}
.brand-zone-image {
  height: 150px;
  margin-bottom: 10px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: #bfbfbf;
  font-size: 36px;
}
.brand-zone-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.brand-zone-image-applicationScenes img {
  object-fit: cover;
}
.brand-zone-field {
  margin-top: 12px;
  margin-bottom: 12px;
}
.brand-zone-field ::v-deep .ant-form-item-label,
.brand-zone-field ::v-deep .ant-form-item-control-wrapper {
  display: block;
  width: 100%;
  text-align: left;
}
.brand-zone-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 12px;
}
</style>
